import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { httpOptions } from 'src/app/global/global_variables';
import { TimeTableInterface } from 'src/app/models/TimeTableModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TimetableService {

  constructor(private http: HttpClient) { }

  postTrip(request: TimeTableInterface): Observable<any> {
    return this.http.post(`${environment.apiLink}/TimeTable/PostTimeTable`, request, httpOptions);
  }

  updateTrip(updateRequest: TimeTableInterface): Observable<any> {
    return this.http.put(
      `${environment.apiLink}/TimeTable/PutTimeTable/${updateRequest.viagem}`,
      updateRequest,
      httpOptions);
  }

  deleteTrip(tripId: number): Observable<any> {
    return this.http.delete(`${environment.apiLink}/TimeTable/DeleteTimeTable?viagem=${tripId}`, httpOptions);
  }

}


